<script>
import RawData from "@/components/widgets/raw-data.vue";
import { required } from "vuelidate/lib/validators";
import Multiselect from "vue-multiselect";
export default {
    name: "ApprovePRModal",
    components: { RawData, Multiselect },
    props: {
        mop: {
            type: Array,
            required: true,
        },
        bacSettings: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            form: {
                id: null,
                bacSettingId: "",
                bacSetting: null,
                bacMembers: [],
                modeOfProcurementId: "",
            },
            submitted: false,
            loading: false,
            bacMemberLoading: false,
            bacMembers: [],
        };
    },
    validations: {
        form: {
            bacSettingId: { required },
            modeOfProcurementId: { required },
        },
    },
    methods: {
        async getBacMembers(id) {
            this.bacMemberLoading = true;
            await this.$store
                .dispatch("bacsetting/GetBacMemberAll", id)
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.bacMembers = res.data;
                })
                .catch(() => {
                    this.showToast("Something went wrong!", "error");
                });
            this.bacMemberLoading = false;
        },
        updateData(data) {
            this.form = JSON.parse(JSON.stringify(data));
            this.bacMembers = [];
            this.$v.$reset();
        },
        selectBacSetting(x){
            this.form.bacSettingId = x.id;
            this.getBacMembers(x.id);
        },
        async onSubmit() {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) return;
            this.$emit("submit", this.form);
        },
    },
};
</script>
<template>
    <b-modal
        id="approve-modal"
        title="Approve Purchase Request"
        size="md"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
    >
        <form @submit.prevent="onSubmit" class="needs-validation">
            <div class="mb-3">
                <label for="description">Select Mode of Procurement </label>
                <select 
                    class="form-select" v-model="form.modeOfProcurementId" 
                    :class="{'is-invalid':  $v.form.modeOfProcurementId.$error}"
                >
                    <option value="">-- Select Mode of Procurement --</option>
                    <option v-for="y in mop" :key="y.id" :value="y.id">{{y.name}}</option>
                </select>
            </div>
            <div class="mb-3">
                <label for="description">Select BAC Setting </label>
                <multiselect
                    v-model="form.bacSetting"
                    :options="bacSettings"
                    label="name"
                    @select="selectBacSetting"
                    track-by="id"
                    value="id"
                    deselect-label=""
                    select-label=""
                    :allow-empty="false"
                    :class="{'is-invalid': $v.form.bacSettingId.$error}"
                />
            </div>
            <div class="mb-3">
                <b-spinner v-if="bacMemberLoading" type="grow" small variant="success" class="ms-2"></b-spinner>
                <div v-if="bacMembers.length && !bacMemberLoading">
                    <h6>BAC Members</h6>
                    <table
                        class="
                            table table-centered
                            align-middle
                            project-list-table
                            border-collapse-none
                        "
                    >
                        <tbody>
                            <tr v-for="x in bacMembers" :key="x.id">
                                <td class="position-relative">
                                    <RawData 
                                        :data="x" 
                                        v-if="$store.state.decrypt.isAdmin()" 
                                        placement="left"
                                        :key="`bacmember-${x.id}`"
                                    />
                                    <div class="d-flex justify-content-between align-items-center">
                                        <div
                                            class="
                                                d-flex
                                                align-items-center
                                            "
                                        >
                                            <div>
                                                <div class="text-warning">
                                                    {{
                                                        x.employee
                                                    }}
                                                </div>
                                                <div>
                                                    <small>
                                                    {{
                                                        x.position
                                                    }}
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div v-if="bacMembers.length == 0 && !bacMemberLoading">
                    <h6>No BAC Members</h6>
                </div>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-primary">
                    Approve PR
                </button>
                <button
                    type="button"
                    class="btn btn-link"
                    @click="$bvModal.hide('approve-modal')"
                >
                    Close
                </button>
            </div>
        </form>
    </b-modal>
</template>